exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".notification-a66cb{margin-bottom:5px}.issues-list-b8db8{margin:0;padding:0}.issues-list-b8db8>li{list-style:none;margin-bottom:5px}.issue-title-b7fd2{margin:0}", ""]);

// Exports
exports.locals = {
	"notification": "notification-a66cb",
	"issues-list": "issues-list-b8db8",
	"issue-title": "issue-title-b7fd2"
};